export default "__VITE_ASSET__Ceh8f4$i__"